import { useCallback } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { toast } from '@/lib/v2/components';

import { copy } from '@/src/utils/Copy';

declare global {
  interface Window {
    __JWTToken?: string;
  }
}

export const useCopyJWT = () => {
  const copyJWT = useCallback(async () => {
    if (!window.__JWTToken) {
      toast({
        title: 'Error',
        body: 'No JWT token available',
        variant: 'error',
      });
      return;
    }

    try {
      await copy(window.__JWTToken);
      toast({
        title: 'Success',
        body: 'JWT token copied to clipboard',
        variant: 'success',
      });
    } catch (error) {
      toast({
        title: 'Error',
        body: 'Failed to copy JWT token',
        variant: 'error',
      });
    }
  }, []);

  useHotkeys(
    'ctrl+shift+alt+c',
    copyJWT,
    {
      preventDefault: true,
    },
    [copyJWT]
  );

  return { copyJWT };
};
